import React, {useMemo, useState} from 'react';
import './style.scss';
import {Popup} from '../../../../components';
import {CommonUtil} from '../../../../utils/CommonUtil';
import {useCurrentUser} from '../../../../layouts/UserContext';
import popupTaskInviteLuka from '../../../../../images/popup-task-invite-luka.png';
import popupTaskInviteLila from '../../../../../images/popup-task-invite-lila.png';
import {APP_PRIZE_COINS} from "../../../../constants";
import { telegramMock } from 'telegram.consts';

const inviteLink = 'https://t.me/tv3_day_ladybug_bot?start={inviteToken}';

export const PopupTaskInvite = ({onClose}) => {
  const {user} = useCurrentUser();
  const [closed, setClosed] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(inviteLink.replace('{inviteToken}', user.telegram_id));
    CommonUtil().showAlert('Ссылка скопирована и её можно отправить другу!');
    setClosed(true);
    window.setTimeout(() => onClose(), 200);
  }

  const share = () => {
    const webApp = window.Telegram.WebApp;
    webApp.openTelegramLink('https://t.me/share/url?url=' + inviteLink.replace('{inviteToken}', user.telegram_id) + '&text=' + encodeURIComponent('Скорее заходи в игру по этой ссылке и помоги мне заработать баллы! 😉🐞'));
  }

  return <Popup
      title="Пригласи друга"
      buttonText="Пригласить друга"
      onButtonClick={share}
      onClose={onClose}
      closed={closed}
  >
    <img src={popupTaskInviteLila} alt="" className="app-popup-task-invite--lila"/>
    <img src={popupTaskInviteLuka} alt="" className="app-popup-task-invite--luka"/>
    <div className="app-popup-task-invite--input">
      <span>{inviteLink.replace('{inviteToken}', user.telegram_id)}</span>
      <svg
          width="16" height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => copyToClipboard()}
      >
        <path d="M2.66665 1.33337C1.92998 1.33337 1.33331 1.93004 1.33331 2.66671V11.3334C1.33331 11.7014 1.63198 12 1.99998 12C2.36798 12 2.66665 11.7014 2.66665 11.3334V2.66671H11.3333C11.7013 2.66671 12 2.36804 12 2.00004C12 1.63204 11.7013 1.33337 11.3333 1.33337H2.66665ZM5.33331 4.00004C4.59665 4.00004 3.99998 4.59671 3.99998 5.33337V13.3334C3.99998 14.07 4.59665 14.6667 5.33331 14.6667H13.3333C14.07 14.6667 14.6666 14.07 14.6666 13.3334V5.33337C14.6666 4.59671 14.07 4.00004 13.3333 4.00004H5.33331ZM5.33331 5.33337H13.3333V13.3334H5.33331V5.33337Z" fill="white"/>
      </svg>
    </div>
    <div className="app-popup--description">
      Скопируй и отправь эту ссылку другу, который еще не&nbsp;присоединился<br/> к&nbsp;игре. Ты получишь
      +<strong><span>{APP_PRIZE_COINS.INVITE}&nbsp;баллов</span></strong> после<br/> того, как он зайдет по&nbsp;ней и сыграет хотя бы одну игру!
    </div>
  </Popup>;
}